import axios from "axios";
import { STRINGS_ENV } from "../config/stringsEnv";

const API_URL = `${STRINGS_ENV.apiUrl}topSellers`;

const topSellersService = {
  getTopSellersGroups: async () => {
    const res = await axios.get(API_URL);
    return res.data?.topSellersCategory ?? [];
  },
};

export default topSellersService;
